// @ts-expect-error // It's okay
import { mapToForm } from 'shared_src/mappings/related_person/to_form'

import IssueQueuer from '../../components/shared/IssueQueuer'
import Allergies from '../../lib/IssueMapping/Allergies'
import Diagnostics from '../../lib/IssueMapping/Diagnostics'
import GOAL from '../../lib/IssueMapping/Goals'
import IN from '../../lib/IssueMapping/Insurance'
import MH from '../../lib/IssueMapping/MedicalHistory'
import MedicalTeam from '../../lib/IssueMapping/MedicalTeam'
import MED from '../../lib/IssueMapping/Medications'
import OR from '../../lib/IssueMapping/Organization'
import SH from '../../lib/IssueMapping/SocialHistory'
import SN from '../../lib/IssueMapping/SupportNetwork'

// import { diagnosisIssueCheckFinished } from "../components/PatientFolder/Standard/MedicalHistory/Diagnosis/actions";

export function igao () {
  // @ts-expect-error // It's okay
  return store => next => action => {
    const storeDispatch = store.dispatch
    const state = store.getState()
    /*
        if (
          action.type === "DIAGNOSIS_ISSUE_CHECK" &&
          state.patient &&
          state.patient.compartment &&
          !state.diagnosis.diagnosisCheck
        ) {
          const entries = state.crudTable.diagnoses.entries
            ? state.crudTable.diagnoses.entries
            : undefined;

          const callback = () => {
            storeDispatch(diagnosisIssueCheckFinished());
          };

          const cb = () => {
            setTimeout(callback, 3000);
          };

          const iq = new IssueQueuer({
            dispatch: storeDispatch,
            patientId: state.patient.id,
            practitionerId: state.auth.profile.sub,
            encounterId: state.encounter.id,
            callBackFn: cb,
          });

          iq.queueIssues({
            mapping: { noDiagnoisDoc: MH.diagnosis.anyDocumentaion },
            currentForm: "",
            existingForms: entries,
          });
        }
    */

    // Check for undocumented medications
    if (action.type === 'MEDICATION_ISSUE_CHECK') {
      const entries = state.crudTable.medications.entries
        // @ts-expect-error // It's okay
        ? state.crudTable.medications.entries.map(item => ({
          item,
          ...item.coding
        }))
        : undefined

      const iq = new IssueQueuer({
        dispatch: storeDispatch,
        patientId: state.globalVars.params.id,
        practitionerId: state.auth.profile.sub,
        encounterId: state.encounter.id,
        practitionerName: [
          state.auth.profile.user_metadata.given,
          state.auth.profile.user_metadata.family
        ].join(' ')
      })

      iq.queueIssues({
        mapping: { noMdeds: MED.medications.anyDocumentaion },
        currentForm: '',
        existingForms: entries
      })
    }

    // Check for undocumented insurance
    if (action.type === 'INSURANCE_ISSUE_CHECK') {
      const entries = state.insurance.items

      const iq = new IssueQueuer({
        dispatch: storeDispatch,
        patientId: state.globalVars.params.id,
        practitionerId: state.auth.profile.sub,
        practitionerName: [
          state.auth.profile.user_metadata.given,
          state.auth.profile.user_metadata.family
        ].join(' '),
        encounterId: state.encounter.id
      })

      iq.queueIssues({
        mapping: { noInsuranceDoc: IN.noInsuranceDoc },
        currentForm: '',
        existingForms: entries.length ? entries : []
      })
    }

    // Allergies
    if (
      action.type === 'crud-table/CREATE_ENTRY_SUCCESS' ||
      action.type === 'crud-table/UPDATE_ENTRY_SUCCESS' ||
      action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
    ) {
      let patientId = state.globalVars?.params?.id
      let practitionerId = state.auth?.profile?.sub
      let encounterId = state?.encounter?.encounter?.id

      if (
        !patientId ||
        !practitionerId ||
        !encounterId
      ) {
        return next(action)
      }

      const iq = new IssueQueuer({
        dispatch: storeDispatch,
        patientId,
        practitionerId,
        encounterId,
        practitionerName: [
          state.auth.profile.user_metadata.given,
          state.auth.profile.user_metadata.family
        ].join(' ')
      })

      if (action.entryType === 'allergy') {
        iq.queueIssues({
          mapping: Allergies,
          currentForm: action.entry,
          existingForms: state.crudTable.allergies.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      // medications
      if (action.entryType === 'medication') {
        const flattenedMED = {
          ...action.entry,
          ...action.entry.coding
        }
        // @ts-expect-error // It's okay
        const entries = state.crudTable.medications.entries.map(item => ({
          item,
          ...item.coding
        }))

        iq.queueIssues({
          mapping: MED.medications,
          currentForm: flattenedMED,
          existingForms: entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      // Immunization
      if (action.entryType === 'immunization') {
        const data = action.entry
        if (
          // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
          data &&
          data.expirationDate &&
          new Date(data.expirationDate).getTime() < new Date().getTime()
        ) {
          data.isExpired = true
        }

        iq.queueIssues({
          mapping: MED.immunizations,
          currentForm: data,
          existingForms: state.crudTable.immunizations.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      // Diagnostics
      if (action.entryType === 'diagnostic') {
        iq.queueIssues({
          mapping: Diagnostics,
          currentForm: action.entry,
          existingForms: state.crudTable.diagnostics.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      // Medical Team Members
      if (action.entryType === 'medicalTeamMember') {
        iq.queueIssues({
          mapping: MedicalTeam,
          currentForm: action.entry,
          existingForms: state.crudTable.medicalTeamMembers.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      // Organizations
      if (action.entryType === 'organizationCareTeamMember') {
        iq.queueIssues({
          mapping: OR,
          currentForm: action.entry,
          existingForms: state.crudTable.organizationCareTeamMembers.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      if (action.entryType === 'insurance') {
        iq.queueIssues({
          mapping: IN,
          currentForm: action.entry,
          existingForms: state.crudTable.insurances.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      if (action.entryType === 'supportMember') {
        // @ts-expect-error // It's okay
        const entries = state.crudTable.supportMembers.entries.map(item => ({
          ...item,
          ...item.narus
        }))

        const newEntry =
          (action.entry.resourceType && mapToForm(action.entry)) ||
          action.entry

        iq.queueIssues({
          mapping: SN,
          currentForm: {
            ...newEntry,
            ...newEntry.narus
          },
          existingForms: entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      if (action.entryType === 'admission') {
        iq.queueIssues({
          mapping: MH.events.admissions,
          currentForm: action.entry,
          existingForms: state.crudTable.admissions.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      if (action.entryType === 'procedure') {
        iq.queueIssues({
          mapping: MH.events.procedures,
          currentForm: action.entry,
          existingForms: state.crudTable.procedures.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      if (action.entryType === 'diagnosis') {
        iq.queueIssues({
          mapping: MH.diagnosis,
          currentForm: action.entry,
          existingForms: state.crudTable.diagnoses.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      if (action.entryType === 'substance') {
        iq.queueIssues({
          mapping: SH.substances,
          currentForm: action.entry,
          existingForms: state.crudTable.substances.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }

      if (action.entryType === 'goal') {
        iq.queueIssues({
          mapping: GOAL,
          currentForm: action.entry,
          existingForms: state.crudTable.goals.entries,
          deleteReference: state.crudTable.deleteReference,
          delete: action.type === 'crud-table/DELETE_ENTRY_SUCCESS'
        })
      }
    }
    return next(action)
  }
}
